$(document).ready(function() {
  var obj = function() {};


  obj.init = function() {
    var videos = $('*:not(.video-wrapper) > iframe[src^="https://www.youtube.com/embed/"]');

    if (videos.length) {
      videos.each(function() {
        var video = $(this);
        video.wrap( "<div class='video-wrapper'></div>" );
      });
    }

    $(document).on('click', '*[data-scroll-to-element-id]', function() {
      var elementId = $(this).attr('data-scroll-to-element-id');
      var element = $('#' + elementId);

      if (element.length) {
        $('html,body').animate({
          scrollTop: element.offset().top
        }, 400);
      }
    });

    return obj;
  };
  obj.init();


  obj.header = function() {

    $(document).on('click', '.header__icon--menu', function() {
      var btn = $(this);

      var menu = btn.parents('.menu-drawer-container');
      menu.addClass('menu-opening');

      var menuDetails = $('#menu-drawer details:not([open])');

      if (menuDetails.length) {

        menuDetails.each(function() {
          var menuDetail = $(this);
          menuDetails.attr('open', true);
        });
      }
    });

    /* Language */
//     if (/DEVMODE/.test(window.location.href)) {
//       $('body').addClass('CC_KT__visible');
//     }
    /* /Language */

    return obj;
  };
  obj.header();


//   obj.lazyLoadEvent = function() {
//     var st = $(window).scrollTop();

//     $('img.lazyload:not(.lazyloaded)').each(function() {
//       var image = $(this);

//       if (st + $(window).height() > image.offset().top) {
//         image.addClass('lazyloaded');

//         if (image.attr('data-widths')) {
//           var imageSizes = JSON.parse(image.attr('data-widths'));

//           var lastNewImageSrc = false;
//           var prelastImageWidth = 0;

//           for (var i = 0; i < imageSizes.length; i++) {
//             var imageSize = imageSizes[i];

//             if (image.width() > prelastImageWidth) {
//               lastNewImageSrc = image.attr('data-src').replace(/\_\{width\}x\./, '_' + imageSize + 'x.');
//               prelastImageWidth = parseInt(imageSize);
//             }
//           }

//           if (lastNewImageSrc) {
//             image.attr('src', lastNewImageSrc);
//           }
//         }
//       }
//     });

//     return obj;
//   };
//   obj.lazyLoadEvent();

//   $(window).resize(function() {
//     obj.lazyLoadEvent();
//   });

//   $(window).scroll(function() {
//     obj.lazyLoadEvent();
//   });


  obj.announcementBar = function() {

    $(document).on('click', '.announcement-bar__message > p', function() {
      var popupId = 'shippingPopupContent';
      obj.showPopupById(popupId);
    });

    return obj;
  };
  obj.announcementBar();

  obj.popup = function() {

    $(document).on('click', '*[data-popup-id]', function(e) {
      e.preventDefault();

      var popupId = $(this).attr('data-popup-id');
      obj.showPopupById(popupId);
    });

    $(document).on('click', '.page-popup__close,.page-popup__bg', function() {
      $('body').removeClass('page-popup__visible');
    });

    return obj;
  };
  obj.popup();

  obj.showPopupById = function(popupId) {
    console.log('click')
    var popups = $('.page-popup__container');

    if (popups.length) {
      popups.addClass('hidden');
    }

    var popup = $('#' + popupId);

    if (popup.length && popup.hasClass('page-popup__container')) {
      popup.removeClass('hidden');
      $('body').addClass('page-popup__visible');

    } else {
      var newPopupContent = $('#' + popupId).clone();
      if (newPopupContent.length) {
        var lastPopupContainer = $('body > .page-popup__container:last');
        lastPopupContainer.find('.page-popup__inner').html(
                '<span class="page-popup__close"></span>'
        ).append(newPopupContent.html());

        lastPopupContainer.removeClass('hidden').find('.page-popup__content').attr('data-content-id', popupId);


        var popupVariantPrice = lastPopupContainer.find('[data-variant-price]')
        if (popupVariantPrice.length) {
          var newUpsellOldPriceValue = $(document).find('.product-single__upsell').find('.product-single__upsell__old-price[data-variant-price]').attr('data-variant-price');

          if ( newUpsellOldPriceValue ) {
            var newUpsellNewPriceValue = $(document).find('.product-single__upsell').find('.product-single__upsell__new-price[data-divided-price]').attr('data-divided-price');

            var popupNewUpsellNewPriceValue = lastPopupContainer.find('[data-divided-price]');
            var popupOldUpsellNewPriceValue = lastPopupContainer.find('[data-variant-price]');

            popupOldUpsellNewPriceValue.attr('data-variant-price', newUpsellOldPriceValue);
            popupOldUpsellNewPriceValue.html(newUpsellOldPriceValue);

            popupNewUpsellNewPriceValue.attr('data-divided-price', newUpsellNewPriceValue);
            popupNewUpsellNewPriceValue.html(newUpsellNewPriceValue);

          }
        }
        $('body').addClass('page-popup__visible');
      }
    }

    return obj;
  };

  if ($('body.template-product').length) {

    obj.product = function() {
      var productObj = function() {};

      productObj.init = function() {
        var productDescriptionQuotes = $('.list-quotes');

        if (productDescriptionQuotes.length) {
          productDescriptionQuotes.owlCarousel({
            loop: false,
            dots: true,
            nav: false,
            responsiveClass: true,
            startPosition: 0,
            margin: 0,
            items: 1,
            autoplay: true,
            autoplayTimeout: 3000
          });
        }

        $(document).on('change', '.product-form__input input[type=radio]', function() {
          
        });

        

        var shippingAccordion = $('.product__info-container .product__accordion:first');

        if (shippingAccordion.length) {
          shippingAccordion.find('p > a').attr('data-popup-id', 'announcementBarPopup');
        }

        var facebookAccordion = $('.product__info-container .product__accordion:last');

        if (facebookAccordion.length) {
          facebookAccordion.attr('data-scroll-to-element-id', 'productFacebook');

          $(document).on('click', '.product__info-container .product__accordion:last', function() {
            var accordion = $(this);

            setTimeout(function() {
              accordion.children('details').removeAttr('open');
            }, 100);
          });
        }


        /* 3D & XR */
        function eventFire(el, etype) {

          if (el.fireEvent) {
            el.fireEvent('on' + etype);

          } else {
            var evObj = document.createEvent('Events');
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
          }
        }

        $(document).on('click', '.product__media-item[data-variant-name]:not(.hidden) .product__media-xr__button', function() {
          var btn = $(this);
          var variant = btn.parents('.product__media-item');
          var variantName = variant.attr('data-variant-name');

          var model = $('.product__xr-models > li[data-variant-name="' + variantName + '"]');

          if (model.length) {
            var modelId = model.attr('data-model-id');

            var xrButton = $('.button.product__xr-button');
            xrButton.attr('data-shopify-model3d-id', modelId);
            xrButton.click();
          }
        });

        $(document).on('click', '.product__media-3d__button', function() {
          var btn = $('#spase-id-button');

          if (btn.length) {
            eventFire(document.getElementById('spase-id-button'), 'click');

            var activeVariant = $('.product-form__input input[type="radio"][data-variant-i]:checked');
            var activeVariantI = parseInt(activeVariant.attr('data-variant-i')) - 1;

            var modelVariantLink = $('#spase-id-modal ul.tab > li.tab-item:eq(' + activeVariantI + ') > a');
            eventFire(modelVariantLink[0], 'click');
          }
        });
        /* /3D & XR */


        $(document).on('click', 'fieldset.product-form__input[data-option-name] label[for]', function(e) {
          e.preventDefault();
          e.stopPropagation();

          var label = $(this);
          var input = label.prev('input[type="radio"]');
          input.prop('checked', true).change();
        });
        $(document).on('click', '.product-form__input-variant', function() {
          var variant = $(this);
          variant.addClass('active').siblings('.active').removeClass('active');

          var variantName = variant.attr('data-variant-name');
          var variantLabel = variant.parents('.product-form__input-variants').siblings('.product-form__input input[type="radio"][value="' + variantName + '"]');

          variantLabel.click().change();
        });

        return productObj;
      };


      $(document).on('click', '.product-media-modal__prev', function() {
        var button = $(this);

        var currentImage = button.siblings('img.active');
        var prevImage = currentImage.prev('img:not(.hidden)');

        var content = $('.product-media-modal__content');
        content.animate({
          scrollTop: prevImage.position().top
        }, 0);
      });

      $(document).on('click', '.product-media-modal__next', function() {
        var button = $(this);

        var currentImage = button.siblings('img.active');
        currentImage.removeClass('active');

        var nextImage = currentImage.next('img:not(.hidden)');

        if (!nextImage.length) {
          var nextImage = currentImage.siblings('img:not(.hidden)').first();
        }

        nextImage.addClass('active');

        var content = $('.product-media-modal__content');
        content.animate({
          scrollTop: nextImage.position().top
        }, 0);
      });

      $(document).on('click', '.product__media-toggle', function() {
        var activeImage = $('.product-media-modal__content > img.active');
        activeImage.siblings('img.active').removeClass('active');
      });

      function removeMyDataAttributes() {
        var list, iterator, attribute, i, n;

        // Select all attribute nodes that it's name starts with "data-myplugin-"
        iterator = document.evaluate('//*/attribute::*[starts-with(local-name(), "data-myplugin-")]',
                document.documentElement, null, XPathResult.ANY_TYPE, null);
        list = [];
        while ((attribute = iterator.iterateNext())) {
          list.push(attribute);
          // Note: can't call removeAttributeNode here:
          // InvalidStateError: Failed to execute 'iterateNext' on 'XPathResult': The document has mutated since the result was returned.
        }
        for (i = 0, n = list.length; i < n; ++i) {
          attribute = list[ i ];
          attribute.ownerElement.removeAttributeNode(attribute);
        }
      }

      productObj.refreshVariants = function() {
        var upsellOptions = {

//          'Yellow': 'Yellow - Black',

          'Birch Premium': 'Birch Premium',
          'Black Core': 'Black',
          'Black Premium': 'Black',
          'Dusk Blue Core': 'Dusk Blue',
          'Olive Premium': 'Olive Premium'

        };

        var activeVariant = $('.product-form__input input[type="radio"]:checked');

        if (!activeVariant.length) {
          var activeVariant = $('.product-form__input input[type="radio"]:first');
        }

        var addToCartPrice = $('#AddToCartPrice .money');

        if (addToCartPrice.attr('data-currency')) {
          addToCartPrice.removeAttr('data-currency-' + window.Shopify.currency.active.toLowerCase());
          addToCartPrice.removeAttr('data-currency-' + addToCartPrice.attr('data-currency'));
          addToCartPrice.removeAttr('data-currency');
        }

        addToCartPrice.text(activeVariant.attr('data-variant-price'));

        var activeVariantName = activeVariant.val();

        var imagesList = $('.product__media-list');
        var images = imagesList.children('.product__media-item');

        images.each(function() {
          var image = $(this);

          if (image.attr('data-variant-name') == activeVariantName) {
            image.removeClass('hidden');

          } else {
            image.addClass('hidden');
          }
        });

        $('.product-media-modal__content > img').each(function() {
          var image = $(this);

          if (image.attr('data-variant-name') == activeVariantName) {
            image.removeClass('hidden');

          } else {
            image.addClass('hidden');
          }
        });


        var formActiveVariant = $('.product-form__input-variants:first .product-form__input-variant').removeClass('active').filter('[data-variant-name="' + activeVariantName + '"]');
        formActiveVariant.addClass('active');


        /* Out of stock message */
        var activeVariantImage = formActiveVariant.find('.form__label-image > img');
        var activeVariantInventoryQuantity = activeVariantImage.attr('data-inventory-quantity');
        var activeVariantOutOfStockMessage = activeVariantImage.attr('data-outofstock-message');

        var outOfStockMessage = $('.product-single__outofstock-message');
        var productFormAlert = $('.product-form__buttons-alert');

        var addToCartPrice = $('#AddToCartPrice > .price');

        if (activeVariantOutOfStockMessage) {
          outOfStockMessage.text(activeVariantOutOfStockMessage).removeClass('hide');

          if (productFormAlert.length) {
            productFormAlert.addClass('hide');
          }

          addToCartPrice.addClass('price--sold-out');

        } else {
          outOfStockMessage.addClass('hide');

          if (productFormAlert.length) {
            productFormAlert.removeClass('hide');
          }

          addToCartPrice.removeClass('price--sold-out');
        }
        /* /Out of stock message */
        
        /* /Out of stock message */

        var upsells = $('.product-single__upsells > .product-single__upsell[data-upsell-url]');

        if (upsells.length) {
          upsells.each(function() {
            var upsell = $(this);
            var upsellImage = upsell.find('.product-single__upsell-left .product-single__upsell-image img');
            var newUpsellImage = productObj.upsellImages[activeVariantName].cover;
            var upsellPriceOld = upsell.find('.product-single__upsell__old-price');
            var upsellPriceNew = upsell.find('.product-single__upsell__new-price');
            var upsellJson = jQuery.parseJSON(upsell.attr('data-js'));

            var upsellOptions = {
              'Black Core': 'Black',
              'Black Premium': 'Black',
              'Dusk Blue Core': 'Dusk Blue',
              'Olive Premium': 'Olive Premium',
              'Birch Premium': 'Birch Premium'
            };
            let activeVariantNameUpsell =  upsellOptions[activeVariantName];

            var newUpsellVar = upsellJson.find(function (el) {
              if(el.title == activeVariantNameUpsell){
                return true;
              }
            });
            let curr = window.market.currency_symbol.replace('.', '');
            let curr_iso_code = window.market.currency_iso_code;
            var newUpsellPrice = (newUpsellVar.price / 100).toFixed(2);
            if(curr == 'kr' && curr_iso_code == 'NOK'){
              var newUpsellPriceDisc = (Number((newUpsellPrice * 0.85).toFixed(2)).toLocaleString("de-DE"))+' '+ curr;
              newUpsellPrice = (Number(newUpsellPrice).toLocaleString("de-DE",{ minimumFractionDigits: 2, maximumFractionDigits: 2 })) +' '+ curr;
            }else if(curr == 'kr' && curr_iso_code == 'SEK'){
              var newUpsellPriceDisc = (Number(newUpsellPrice * 0.85).toLocaleString("ru-RU",{ minimumFractionDigits: 2, maximumFractionDigits: 2 }))+' '+ curr;
              newUpsellPrice = (Number(newUpsellPrice*1).toLocaleString("ru-RU",{ minimumFractionDigits: 2, maximumFractionDigits: 2 })) +' '+ curr;
            }else if(curr == 'kr' && curr_iso_code == 'DKK'){
              var newUpsellPriceDisc = (Number((newUpsellPrice * 0.85).toFixed(2)).toLocaleString("de-DE"))+' '+ curr;
              newUpsellPrice = (Number(newUpsellPrice).toLocaleString("de-DE",{ minimumFractionDigits: 2, maximumFractionDigits: 2 })) +' '+ curr;
            }else{
              var newUpsellPriceDisc = curr + (Number((newUpsellPrice * 0.85)).toLocaleString('de-DE',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }));
              newUpsellPrice = curr + (Number(newUpsellPrice).toLocaleString("de-DE",{ minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            }

            if (upsell.attr('data-upsell-url') == '/products/sunshade') {

            } else {
              if(false){

              }else{
                upsellPriceOld.text(newUpsellPrice)
                upsellPriceOld.attr('data-variant-price', newUpsellPrice)
                upsellPriceNew.text(newUpsellPriceDisc)
                upsellPriceNew.attr('data-divided-price', newUpsellPriceDisc);
                upsellImage.attr('src', newUpsellImage);
              }
            }



            var productVariantsJson;
            let interval = setInterval(fun, 10);
            function fun() {
              if (upsell.find('.product__variants-json').length) {

                productVariantsJson = upsell.find('.product__variants-json');

                if (productVariantsJson.length) {


                  var productVariants = JSON.parse(productVariantsJson.text().trim());
                  for (var productVariantI = 0; productVariantI < productVariants.length; productVariantI++) {
                    var productVariant = productVariants[productVariantI];
                    if ($('[data-option-name="mlveda_country"]').length) {
                      var upsellCurrentColor = $('.product-form__input[data-option-name="Color"] input:checked').attr("value");
                      var upsellCurrentLang = $('.product-form__input[data-option-name="mlveda_country"] input:checked').attr("value");
                      var upsellOptionsColorLang = upsellCurrentColor + ' / ' + upsellCurrentLang
                      if (upsellOptionsColorLang == productVariant.title) {
                        var productVariantInput = upsell.find('.product-single__upsell-form input[name="id"]');
                        productVariantInput.val(productVariant.id);
                      }
                    } else {
                      var productVariantInput = upsell.find('.product-single__upsell-form input[name="id"]');
                      if (upsellOptions[activeVariantName] == productVariant.title && productVariant.available) {
                        productVariantInput.val(productVariant.id);
                        upsell.removeClass('hidden');
                        upsell.closest('.product__info-container').find('#AddToCartBg').removeClass('hidden');
                        break;
                      }else{
                        productVariantInput.val('');
                        upsell.addClass('hidden');
                        upsell.closest('.product__info-container').find('#AddToCartBg').addClass('hidden');
                      }
                    }



//                 console.log('___activeVariantName', activeVariantName, 'found', productVariant.id);
                  }
                }

                clearInterval(interval);
              }
            }






            /* Video thumbnail */
            if ($(window).width() < 767) {
              var thumbnailVideo = $('.product__video-item:visible .product__video-item__content');

              if (thumbnailVideo.length) {
                var currentSlide = $('.product__media-wrapper .slider-counter > .slider-counter--current').text();

                var thumbnailVideoElem = thumbnailVideo.find('video');

                if (currentSlide == 2) {
                  thumbnailVideoElem.get(0).play();

                } else {
                  thumbnailVideoElem.get(0).pause();
                }
              }

            } else {
              var thumbnailVideo = $('.product__video-item:not(.hidden) .product__video-item__content');

              if (thumbnailVideo.length) {
                var thumbnailVideoElem = thumbnailVideo.find('video');

                var thumbnailVideoPopup = $('.product__video-item__popup');
                var thumbnailVideoPopupElem = thumbnailVideoPopup.find('video');

                thumbnailVideoElem.get(0).play();
              }
            }
            /* /Video thumbnail */
          });
        }


        var lastMediaItems = $('.product__media-wrapper ul.product__media-list > li.product__media-item');
        lastMediaItems.filter('.first').removeClass('first');
        lastMediaItems.filter('.last').removeClass('last');

        var visibleMediaItems = lastMediaItems.filter(':not(.hidden)');
        $('.slider-counter--total').text(visibleMediaItems.length);

        var lastMediaItem = $('.product__media-wrapper ul.product__media-list > li.product__media-item:not(.hidden)');

        visibleMediaItems.first().addClass('first');
        visibleMediaItems.last().addClass('last');


        return productObj;
      };
      productObj.upsellImages = {

        'Birch Premium': {
          'cover': 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBirch_variantimg.png?v=1713502908',
          'images': [
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBirch_01.jpg?v=1713502902',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBirch_07.jpg?v=1713502902',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBirch_03.jpg?v=1713502904',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBirch_08.jpg?v=1713502904'
          ]
        },
        'Black Core': {
          'cover': 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBlack_variantimg.png?v=1713502902',
          'images': [
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_01.jpg?v=1713502907',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_07.jpg?v=1713502905',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_03.jpg?v=1713502905',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_06.jpg?v=1713502901'
          ]
        },
        'Dusk Blue Core': {
          'cover': 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBlue_variantimg.png?v=1713502905',
          'images': [
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPDuskBlue_01.jpg?v=1713502910',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPDuskBlue_06.jpg?v=1713502902',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPDuskBlue_03.jpg?v=1713502901',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPDuskBlue_05.jpg?v=1713502906'
          ]
        },
        'Black Premium': {
          'cover': 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBlack_variantimg.png?v=1713502902',
          'images': [
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_01.jpg?v=1713502907',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_07.jpg?v=1713502905',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_03.jpg?v=1713502905',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPBlack_06.jpg?v=1713502901'
          ]
        },
        'Olive Premium': {
          'cover': 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPOlive_variantimg.png?v=1713502902',
          'images': [
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPOlive_01.jpg?v=1713502903',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPOlive_09.jpg?v=1713502906',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPOlive_03.jpg?v=1713502904',
            'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/HeroBPOlive_05.jpg?v=1713502903'
          ]
        }
      };

      productObj.upsell = function() {
        var upsells = $('.product-single__upsell');

        var upsellOptions = {


          'Birch Premium': 'Birch',
          'Black Core': 'Black',
          'Black Premium': 'Black',
          'Dusk Blue Core': 'Dusk Blue',
          'Olive Premium': 'Olive'

        };

        if (upsells.length) {

          upsells.each(function(upsellI) {
            var upsell = $(this);
            var upsellPopup = $('#productUpsellPopupContent');
            var upsellLink = upsell.attr('data-upsell-url');
            $.ajax({
              url: upsellLink,
              dataType: 'html',
              type: 'get',
              success: function(result) {
                var ajaxUpsell = $(result).find('.product-single__upsell-hidden');
                if (ajaxUpsell.length) {
                  if($(result).find('.product-single__upsell-hidden').data('available') == false){
                    upsell.each( function(el) {
                      upsell[el].classList.add( "hidden" );
                    })

                  }

                  upsell.html(ajaxUpsell.html());
                  upsell.find('.product-single__upsell-right').after($(result).find('.product-single__upsell-details__popup')[0].outerHTML);

                  var newCTAPopupId = 'productCTAPopup' + upsellI + 'Content';
                  upsell.find('.product-single__upsell-cta__popup').attr('id', newCTAPopupId);

                  var addToCartBg = $('#AddToCartBg');

                  if (!addToCartBg.length) {
                    var addToCartBtn = $('#AddToCart');
                    addToCartBtn.after(
                            '<span id="AddToCartBg" data-popup-id="' + newCTAPopupId + '"></span>'
                    );
                  }

                  var newDetailsPopupId = 'productDetailsPopup' + upsellI + 'Content';
                  upsell.find('.product-single__upsell-details__popup').attr('id', newDetailsPopupId);
                  upsell.find('.product-single__upsell-text .text-link').attr('data-popup-id', newDetailsPopupId);

                  var ajaxForm = $(result).find('.product-form > form');
                  var ajaxFormFields = ajaxForm.find('select, input');

                  if (ajaxFormFields.length) {
                    upsell.append(
                            '<form class="product-single__upsell-form hidden"></form>'
                    );

                    var upsellForm = upsell.find('.product-single__upsell-form');
                    upsellForm.attr('data-ajax-url', ajaxForm.attr('action'));

                    ajaxFormFields.each(function() {
                      var ajaxFormField = $(this);

                      ajaxFormField.removeAttr('id').removeAttr('class');
                      upsellForm.append(ajaxFormField);
                    });

                    var productVariantsJson = $(result).find('.product__variants-json');
                    upsellForm.append(productVariantsJson);

                    var activeVariant = $('.product-form__input input[type="radio"]:checked');

                    if (!activeVariant.length) {
                      var activeVariant = $('.product-form__input input[type="radio"]:first');
                    }

                    var activeVariantName = activeVariant.val();

                    var productVariants = JSON.parse(productVariantsJson.text().trim());

                    for (var productVariantI = 0; productVariantI < productVariants.length; productVariantI++) {
                      var productVariant = productVariants[productVariantI];

                      if (upsellOptions[activeVariantName] == productVariant.title) {
                        var productVariantInput = upsell.find('.product-single__upsell-form input[name="id"]');
                        productVariantInput.val(productVariant.id);
                      }
                    }
                  }

                  var upsellImage = upsell.find('.product-single__upsell-left .product-single__upsell-image img');
                  var newUpsellImage = productObj.upsellImages[activeVariantName].cover;
                   upsellImage.attr('src', newUpsellImage);
                }
              }
            });
          });
        }

        $(document).on('click', '.product-single__upsell-right > p .text-link', function() {
          var upsellImages = $('.product-single__upsell-popup__images');

          if (upsellImages.length && false) {
            upsellImages.owlCarousel({
              loop: true,
              dots: false,
              nav: true,
              responsiveClass: true,
              lazyLoad: true,
              startPosition: 0,
              responsive: {
                0: {
                  margin: 5,
                  items: 1
                },
                768: {
                  margin: 5,
                  items: 3
                }
              }
            });
          }
        });

        $(document).on('click', '.page-popup__content[data-content-id="productCTAPopup0Content"] .button--primary', function() {
          var btn = $(this);
          btn.prop('disabled', true);

          var popupContentId = btn.parents('.page-popup__content').attr('data-content-id');
          var popupContent = $('#' + popupContentId);

          var upsellForm = popupContent.next('.product-single__upsell-form');

          var upsellOptions = {

            'Birch Premium': 'Birch',
            'Black Core': 'Black',
            'Black Premium': 'Black',
            'Dusk Blue Core': 'Dusk Blue',
            'Olive Premium': 'Olive'
          };

          $.ajax({
            url: upsellForm.attr('data-ajax-url'),
            data: upsellForm.find('input, select').serialize(),
            dataType: 'html',
            type: 'post',
            success: function(result) {
              var addToCartBtn = $('#AddToCart');
              addToCartBtn.click();
            }
          });
        });

        $(document).on('click', '.page-popup__content[data-content-id="productCTAPopup0Content"] .button--secondary', function() {
          var btn = $(this);
          btn.prop('disabled');

          var addToCartBtn = $('#AddToCart');
          addToCartBtn.click();
        });

        $(document).on('click', '.page-popup__content[data-content-id="productCTAPopup0Content"] .page-popup__bg,.page-popup__content[data-content-id="productCTAPopup0Content"] .page-popup__close', function() {
          var btn = $(this);
          btn.prop('disabled');

          var addToCartBtn = $('#AddToCart');
          // addToCartBtn.click();
        });

        $(document).on('click', '#AddToCartBg', function() {
          var btn = $(this);

          var variant = $('.product-form__input input[type=radio]:checked');

          if (!variant.length) {
            var variant = $('.product-form__input input[type=radio]:first');
          }

          var variantText = variant.val();

          var popupImages = $('div[data-content-id="productCTAPopup0Content"] .product-single__upsell-popup__images');
          popupImages.html('');

          for (var i = 0; i < productObj.upsellImages[variantText]['images'].length; i++) {
            popupImages.append(
                    '<li data-i="' + i + '">' +
                    '<img src="' + productObj.upsellImages[variantText]['images'][i] + '" alt="" />' +
                    '</li>'
            );
          }

          popupImages.owlCarousel({
            loop: true,
            dots: false,
            nav: true,
            responsiveClass: true,
            lazyLoad: true,
            startPosition: 0,
            responsive: {
              0: {
                margin: 5,
                items: 1
              },
              768: {
                margin: 5,
                items: 3
              }
            }
          });
        });

        return productObj;
      };

      productObj.upsell();

      productObj.bundle = function() {
        var productBundleObj = function() {};

        productBundleObj.init = function() {

//           $(document).on('click', 'variant-radios > .product-form__input > .product-form__input-variants .product-form__input-variant', function() {
//             productBundleObj.refreshItems();
//           });

          $(document).on('change', 'variant-radios > .product-form__input > input[type="radio"]', function() {
            productBundleObj.refreshItems();
          });


          $(document).on('click', '.product-single__bundle-item .product-form__input[data-option-name="Size"] .product-form__input-variant', function() {
            $('#AddToCart').prop('disabled', false);
          });


          /* Bundle item option */
          $(document).on('click', '.product-single__bundle-item .product-single__option ul > li:not(.active)', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var bundleItemOptionVariant = $(this);
            bundleItemOptionVariant.addClass('active').siblings('.active').removeClass('active');

            var bundleItemOptionVariantValue = bundleItemOptionVariant.attr('data-variant');

            if (bundleItemOptionVariant.hasClass('product-single__option__variant-image')) {
              var bundleItemOption = bundleItemOptionVariant.parent('ul').parent('.product-single__option');

            } else {
              var bundleItemOption = bundleItemOptionVariant.parent('ul').parent('div').parent('.product-single__option');
            }

            var bundleItemOptionTitle = bundleItemOption.attr('data-option-title');
            var bundleItemOptions = bundleItemOption.parent('.product-single__options').children('.product-single__option');

            var bundleItemSelector = bundleItemOption.parent('.product-single__options').siblings('select.product-single__variants');
            var bundleItemSelectorValue = '';

            bundleItemOptions.each(function(bundleItemOptionI) {
              var bundleItemOption = $(this);

              if (!bundleItemOptionI) {
                bundleItemSelectorValue += bundleItemOption.find('ul > li.active').attr('data-variant');

              } else {
                bundleItemSelectorValue += ' / ' + bundleItemOption.find('ul > li.active').attr('data-variant');
              }
            });

            var bundleItemSelectorOption = bundleItemSelector.children('option[data-variant-title="' + bundleItemSelectorValue + '"]');
            bundleItemSelector.val(bundleItemSelectorOption.attr('value'));
          });
          /* /Bundle item option */

          productBundleObj.loadItems();

          $(document).on('click', '#AddToCartBundleBg.loaded', function() {

            if ($('#AddToCart:not([disabled])').length) {
              productBundleObj.addToCart();
            }
          });


          $(document).on('click', '.product-single__bundle-item .product-form__input-variant', function(event) {
            var variant = $(this);
            variant.addClass('active').siblings('.active').removeClass('active');

            var variantName = variant.attr('data-variant-name');
            var variantInput = variant.parents('.product-form__input-variants').siblings('input[type="radio"][value="' + variantName + '"]');

            if (variantInput.length) {
              var variantId = variantInput.attr('data-variant-id');

              var formInput = variant.parents('.product-single__bundle-item').children('input[name="id"]');

              var bundleItem = variant.parents('.product-single__bundle-item');
              var bundleItemOptions = bundleItem.children('.product-form__input');

              var variantTitle = '';

              if (bundleItemOptions.length == 2) {

                bundleItem.find('.product-form__input-variant.active').each(function(bundleItemOptionI) {
                  var bundleItemOption = $(this);
//                   var bundleItemOptionValue = bundleItemOption.find('.product-form__input-variant.active').val();

                  if (bundleItemOptionI) {
                    variantTitle += ' / ' + bundleItemOption.attr('data-variant-name');

                  } else {
                    variantTitle = bundleItemOption.attr('data-variant-name');
                  }
                });

//                 bundleItemOptions.each(function(bundleItemOptionI) {
//                   var bundleItemOption = $(this);
//                   var bundleItemOptionValue = bundleItemOption.find('input[type="radio"]:checked').val();

//                   if (bundleItemOptionI) {
//                     variantTitle += ' / ' + bundleItemOptionValue;

//                   } else {
//                     variantTitle = bundleItemOptionValue;
//                   }

//                   console.log('variantTitle', variantTitle);
//                 });

                var variantsJson = JSON.parse(variant.parents('.product-form__input').siblings('.product__variants-json').text());

                for (const variantJson of variantsJson) {
                  /*varinat id change in form*/
                  if (variantJson.title == variantTitle) {
                    formInput.val(variantJson.id);
                    if (variantJson.available == false) {
                      $('#AddToCart').prop('disabled', true);
                      $('#AddToCart').find('#AddToCartText')[0].innerHTML="Sold out";
                    } else {
                      $('#AddToCart').prop('disabled', false);
                      $('#AddToCart').find('#AddToCartText')[0].innerHTML="I'm interested";
                    }
                    if(!$(event.target).closest('.product-form__input-variant ').hasClass('size-option')) {
                      if (variantJson.available == false) {
                        var availableVariant = variantsJson.find(vari => {
                          return vari.option1 == variantJson.option1 && vari.available == true
                        });
                        if (availableVariant != undefined){
                          $(`.product-form__input-variant[data-variant-name="${availableVariant.option2}"]`).click();
                        }
                      }
                    }
                  }
                }

              } else {
                formInput.val(variantId);
              }
            }
          });

          return productBundleObj;
        };

        productBundleObj.refreshItems = function() {
          var selector = $('.product-form > .selector-wrapper > select.single-option-selector');
          var selectorValue = selector.val();

          var activeOption = $('variant-radios > .product-form__input > input[type="radio"]:checked');
          var activeOptionI = activeOption.attr('data-variant-i');

          var bundleItems = $('.product-single__bundle-items > .product-single__bundle-item');

          if (bundleItems.length) {
            var activeVariant = $('.product-form__input input[type="radio"]:checked');
            var activeVariantName = activeVariant.val();

            bundleItems.each(function() {
              var bundleItem = $(this);

              var bundleItemTitle = bundleItem.attr('data-item-title');

              if (bundleItemTitle) {
                var bundleItemNewValue = null;

                switch (bundleItemTitle) {

                  case 'MiniMeis G5 Shoulder Carrier':

                    switch (activeVariantName) {

                      case 'Navy':
                        var bundleItemNewValue = 'Black Navy';
                        break;

                      case 'Yellow':
                        var bundleItemNewValue = 'Yellow';
                        break;

                      case 'Grey Orange':
                        var bundleItemNewValue = 'Grey - Orange';
                        break;

                      case 'Burgundy':
                        var bundleItemNewValue = 'Burgundy';
                        break;

                      case 'Grey':
                        var bundleItemNewValue = 'Black Grey';
                        break;
                    }

                    var activeBundleItemVariant = bundleItem.find('.product-form__input-variant[data-variant-name="' + bundleItemNewValue + '"]');
                    activeBundleItemVariant.click();

//                   bundleItem.children('input[name="id"]').val(activeVariant.attr('data-variant-id'));
                    break;

                  case 'Gamechanger shoes':

                    switch (activeVariantName) {

                      case 'Navy':
                        var bundleItemNewValue = 'Multi Navy';
                        break;

                      case 'Yellow':
                        var bundleItemNewValue = 'Multi Yellow';
                        break;

                      case 'Grey Orange':
                        var bundleItemNewValue = 'Grey & Orange';
                        break;

                      case 'Burgundy':
                        var bundleItemNewValue = 'Black & Burgundy';
                        break;

                      case 'Grey':
                        var bundleItemNewValue = 'Grey & Orange';
                        break;
                    }

                    var activeBundleItemVariant = bundleItem.find('.product-form__input-variant[data-variant-name="' + bundleItemNewValue + '"]');
                    activeBundleItemVariant.click();

//                   bundleItem.children('input[name="id"]').val(activeVariant.attr('data-variant-id'));
                    break;

                  case 'The Backpack':

                    switch (activeVariantName) {

                            /* /Grey Orange and Navy BP OOS all stores June 22 2022 */

                      case 'Navy':
                        var bundleItemNewValue = 'Navy Blue';
                        break;

                      case 'Grey Orange':
                        var bundleItemNewValue = 'Grey - Melange';
                        break;

                      case 'Yellow':
                        var bundleItemNewValue = 'Yellow - Black';
                        break;


                      case 'Burgundy':
                        var bundleItemNewValue = 'Burgundy - Black';
                        break;

                      case 'Grey':
                        var bundleItemNewValue = 'Dark Grey';
                        break;
                  }

                  var activeBundleItemVariant = bundleItem.find('.product-form__input-variant[data-variant-name="' + bundleItemNewValue + '"]');
                  activeBundleItemVariant.click();

//                   bundleItem.children('input[name="id"]').val(activeVariant.attr('data-variant-id'));
                    break;
                }

//               if (bundleItemNewValue) {
//                 var bundlePropertyField = $('.product-single__bundle-properties input[name="properties[' + bundleItemTitle + ']"]');
//                 bundlePropertyField.val(bundleItemNewValue);
//               }
              }
            });
          }
          /* /Bundles */

          return productObj;
        };

        productBundleObj.loadItems = function() {
          var bundleItems = $('.product-single__bundle-item:not(.loaded)');

          if (bundleItems.length) {

            bundleItems.each(function() {
              var bundleItem = $(this);
              var bundleItemI = bundleItem.index();
              var bundleItemURI = bundleItem.attr('data-item-uri');

              $.ajax({
                url: bundleItemURI,
                dataType: 'html',
                type: 'get',
                success: function(result) {
                  var bundleProductForm = $(result).find('.product-form > form');

                  var bundleItemId = bundleProductForm.attr('id') + '_' + bundleItemI;
                  bundleItem.attr('id', bundleItemId).attr('action', bundleProductForm.attr('action'));

                  bundleProductForm.find('.product-form__buttons').remove();

                  var bundleProductFormOption = $(result).find('variant-radios');
                  bundleProductFormOption.find('.product-form__input').removeClass('js');

                  var bundleItemSelector = $(result).find('.product-form__input');
                  var bundleItemTitle = bundleItemSelector.attr('data-product-title');

                  if (bundleItemTitle == 'Gamechanger shoes') {
                    var activeSizeBtn = bundleProductFormOption.find('.product-single__option__variant-button.active');

                    if (activeSizeBtn.length) {
                      activeSizeBtn.removeClass('active');
                      $('.product-single__cart-submit-wrapper').addClass('disabled');
                    }

                    var sizePopup = $(result).find('#shoeSizePopupContent');

                    if (sizePopup.length) {
                      $('body').append(sizePopup);
                    }

                  } else {
                    bundleItem.addClass('invisible');

                    if (/DEVMODE/.test(window.location.href)) {
                      $('.product-single__bundle-item.invisible').removeClass('invisible');
                      $('.product-form__input input[type="radio"], .product-form__input label[for]').attr('style', 'clip: auto !important; overflow: visible; position: static !important; height: auto !important; width: auto !important');
                    }
                  }

                  bundleItem.attr('data-item-title', bundleItemTitle).append(
                          bundleProductForm.html() +
                          bundleProductFormOption.html()
                  );

                  bundleItem.find('.product-form__input').each(function() {
                    $(this).find('input[type="radio"]').attr('form', bundleItemId);

//                     $(this).find('.product-form__input-variant:first').click();
                  });

                  var unloadedBundleItems = $('.product-single__bundle-item:not(.loaded)');

                  if (unloadedBundleItems.length) {
                    $('#AddToCart').prop('disabled', true);
                    $('#AddToCartBundleBg').addClass('loaded');

                    productBundleObj.refreshItems();
                  }
                }
              });
            });
          }

          return productBundleObj;
        };

        productBundleObj.addFirstItemToCart = function(i) {
          var bundleItem = $('.product-single__bundle-items > .product-single__bundle-item:not(.added):first');

          if (bundleItem.length) {

            $.ajax({
              url: bundleItem.attr('action'),
              data: bundleItem.serialize(),
              type: 'post',
              success: function() {
                bundleItem.addClass('added').css('opacity', '0.5');
                productBundleObj.addFirstItemToCart();
              }
            });

          } else {
            var bundleForm = $('.product-form > form');
            var bundleFormData = $('.product-form > form > input, .product-form > form > select, .product-single__bundle-properties input').serialize();

            $.ajax({
              url: bundleForm.attr('action'),
              data: bundleFormData,
              type: 'post',
              success: function() {
                var cartBtn = $('#cart-icon-bubble');
                window.location.href = cartBtn.attr('href');
              }
            });
          }

          return productBundleObj;
        };

        productBundleObj.addToCart = function() {
          $('.product-form__buttons').addClass('disabled');

          var originalBtn = $('#AddToCart');
          originalBtn.prop('disabled', true);

          var bundleId = productObj.makeId(10);

          $('.product-single__bundle-item, .product-form > form').append(
                  '<input type="hidden" name="properties[Bundle ID]" value="' + bundleId + '">'
          );

          productBundleObj.addFirstItemToCart();

          return productBundleObj;
        };

        productBundleObj.init();

        return productBundleObj;
      };

      productObj.makeId = function(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;

        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
      };

      productObj.bundle();


      productObj.facebook = function() {

        $(window).on('scroll resize load', function() {
          var st = $(window).scrollTop();

          var facebook = $('.product-single__facebook');

          if (facebook.length) {
            var facebookLeft = $('.product-single__facebook-left');
            var facebookTitle = $('.product-single__facebook-title');

            if (st + facebookTitle.outerHeight() > facebook.offset().top + facebook.height()) {
              facebookTitle.removeClass('floating').addClass('floating-bottom').width(facebookLeft.width());

            } else if (st > facebook.offset().top) {
              facebookTitle.addClass('floating').removeClass('floating-bottom').width(facebookLeft.width());

            } else {
              facebookTitle.removeAttr('style').removeClass('floating').removeClass('floating-bottom');
            }
          }
        });

        return productObj;
      };

      productObj.facebook();


      productObj.shoulderCarrierVariantsSlider = function() {

        var shoulderCarrierVariants = $('.product-form__input[data-product-title="MiniMeis G5 Shoulder Carrier"] .product-form__input-variants');
//         var shoulderCarrierVariants = $('.product-form__input:first .product-form__input-variants');

        if (shoulderCarrierVariants.length) {

          if ($(window).width() >= 992) {

            if (shoulderCarrierVariants.hasClass('owl-carousel')) {
              shoulderCarrierVariants.trigger('destroy.owl.carousel');
            }

          } else {

            if (!shoulderCarrierVariants.hasClass('owl-carousel')) {
              shoulderCarrierVariants.addClass('owl-carousel').addClass('owl-theme').owlCarousel({
                loop: false,
                dots: false,
                nav: false,
                responsiveClass: true,
                lazyLoad: true,
                startPosition: 0,
                margin: 0,
                responsive: {
                  0: {
                    stagePadding: 40,
                    items: 4
                  },
                  992: {
                    items: 6
                  }
                }
              });
            }
          }
        }

        return productObj;
      };

//       productObj.shoulderCarrierVariantsSlider();


      productObj.thumbnailVideo = function() {
        var thumbnailVideo = $('.product__video-item:not(.hidden) .product__video-item__content');

        if (thumbnailVideo.length) {
          var thumbnailVideoElem = thumbnailVideo.find('video');

          var thumbnailVideoPopup = $('.product__video-item:not(.hidden) .product__video-item__popup');
          var thumbnailVideoPopupElem = thumbnailVideoPopup.find('video');

          /* Thumbnail video */
          if ($(window).width() < 767) {
            thumbnailVideoElem.get(0).pause();

          } else {
            thumbnailVideoElem.get(0).play();
          }
        }

        $(window).resize(function() {
          var thumbnailVideo = $('body:not(.page-popup__visible) .product__video-item:not(.hidden) .product__video-item__content');

          if (thumbnailVideo.length) {
            var thumbnailVideoElem = thumbnailVideo.find('video');

            if ($(window).width() < 767) {
              thumbnailVideoElem.get(0).pause();

            } else {
              thumbnailVideoElem.get(0).play();
            }
          }
        });
        /* /Thumbnail video */

        $(document).on('click', '.product__video-item__popup-pause', function() {
          var pauseBtn = $(this);
          pauseBtn.toggleClass('paused');

          var video = pauseBtn.siblings('video');

          if (pauseBtn.hasClass('paused')) {
            video.get(0).pause();

          } else {
            video.get(0).play();
          }
        });

        $(document).on('click', '.product__video-item__content', function() {
          var thumbnailVideo = $('.product__video-item:not(.hidden) .product__video-item__content');

          var thumbnailVideoElem = thumbnailVideo.find('video');
          thumbnailVideoElem.get(0).pause();

          var popupId = thumbnailVideo.siblings('.product__video-item__popup').attr('id');
          obj.showPopupById(popupId);
        });

        $(document).on('click', '.page-popup__container .page-popup__content[data-content-id^="productThumbnailVideoPopup"] .page-popup__close, .page-popup__container .page-popup__content[data-content-id^="productThumbnailVideoPopup"] .page-popup__bg', function() {
          var thumbnailVideo = $('.product__video-item:not(.hidden) .product__video-item__content');

          var thumbnailVideoElem = thumbnailVideo.find('video');
          thumbnailVideoElem.get(0).play();

          var thumbnailVideoPopup = $('.product__video-item:not(.hidden) .product__video-item__popup');
          var thumbnailVideoPopupElem = thumbnailVideoPopup.find('video');

          thumbnailVideoPopupElem.attr('playsinline', '');
        });

        $(document).on('click', '.product__video-item__popup-fullscreen', function() {
          var btn = $(this);

          var video = btn.siblings('video');
          toggleFullScreen(video);
        });

        return productObj;
      };

      productObj.thumbnailVideo();


      productObj.init();
    };
    obj.product();

  } else if ($('body.template-cart').length) {

    obj.cart = function() {
      var cartObj = function() {};

      cartObj.init = function() {
        cartObj.upsell();
        cartObj.bundle();

        return cartObj;
      };

      cartObj.bundle = function() {

        $(document).on('change', '.cart-item[data-bundle="true"] .cart-item__quantity .quantity__input', function(e) {
          e.preventDefault();
          e.stopPropagation();

          var quantityInput = $(this);
          var quantityValue = quantityInput.val();

          var bundle = quantityInput.parents('.cart-item');
          var bundleId = bundle.attr('data-bundle-id');

          var bundleItems = bundle.siblings('.cart-item[data-bundle-item="true"][data-bundle-id="' + bundleId + '"]');

          if (bundleItems.length) {

            bundleItems.each(function() {
              var bundleItem = $(this);
              var bundleItemQuantityInput = bundleItem.find('.cart-item__quantity .quantity__input');
              bundleItemQuantityInput.val(quantityValue);
              bundleItem.find('.cart-item__quantity > div').text(quantityValue);
            });
          }

          var cartForm = $('form#cart');

          $.ajax({
            url: cartForm.attr('action'),
            data: cartForm.serialize(),
            dataType: 'html',
            type: cartForm.attr('method'),
            success: function (result) {
              window.location.href = $('.header__icon--cart').attr('href');
            }
          });
        });


        $(document).on('click', '.cart-item__remove-button', function(e) {
          e.preventDefault();
          e.stopPropagation();

          var removeLink = $(this);

          var bundle = removeLink.parents('.cart-item');
          var bundleTitle = bundle.attr('data-item-title');

          var bundleID = bundle.attr('data-bundle-id');

          if (bundleID) {
            var bundleItems = bundle.siblings('.cart-item[data-bundle-item="true"][data-bundle-title="' + bundleTitle + '"][data-bundle-id="' + bundleID + '"]');
          }

          if (bundleItems.length) {

            bundleItems.each(function(i) {
              var bundleItem = $(this);

              var bundleItemQuantity = bundleItem.find('.quantity__input');
              bundleItemQuantity.val(0);
            });
          }

          var bundleQuantity = bundle.find('.quantity__input');
          bundleQuantity.val(0);

          var cartForm = $('form#cart');

          $.ajax({
            url: cartForm.attr('action'),
            data: cartForm.serialize(),
            dataType: 'html',
            type: cartForm.attr('method'),
            success: function (result) {
              bundleItems.remove();
              bundle.remove();

              window.location.href = $('.header__icon--cart').attr('href');
            }
          });

        });

        return cartObj;
      };

      cartObj.upsell = function() {
        var cartUpsellObj = function() {};

        let productColor = $('.cart-item[data-item-title="MiniMeis G5 Shoulder Carrier"]:first, .cart-item[data-item-title="MiniMeis G5 Carregador de Ombro"]:first').find('.cart-item__name').next('dl').children('div:first').text().trim();
        let storeLocale = window.location.pathname.split('/cart')[0];
        let upsellVar = [
          {
            product_color: 'Black Core',
            color: 'Black',
            uri: storeLocale + '/products/minimeis-hero-parent-backpack?variant=43352870682796'
          }, {
            product_color: 'Dusk Blue Core',
            color: 'Dusk Blue',
            uri: storeLocale + '/products/minimeis-hero-parent-backpack?variant=43352870715564'
          }, {
            product_color: 'Black Premium',
            color: 'Black',
            uri: storeLocale + '/products/minimeis-hero-parent-backpack?variant=43352870682796'
          }, {
            product_color: 'Olive Premium',
            color: 'Olive Premium',
            uri: storeLocale + '/products/minimeis-hero-parent-backpack?variant=43352870748332'
          }, {
            product_color: 'Birch Premium',
            color: 'Birch Premium',
            uri: storeLocale + '/products/minimeis-hero-parent-backpack?variant=43352870781100'
          }
        ];
        let uri;
        upsellVar.forEach(function (item) {
          if(item.product_color == productColor){
            uri = item.uri;
          }
        })



        cartUpsellObj.data = {
          upsells: [
            
          {
            title: 'MiniMeis Hero Parent Backpack',
            uri: uri,
            variants: [
              /* MMRS Burgundy out of stock FS (original) */
              {
                product_color: 'Black Core',
                color: 'Black',
                image: 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBlack_variantimg.png?v=1713502902',
                productJson: [[]]
              }, {
                product_color: 'Dusk Blue Core',
                color: 'Dusk Blue',
                image: 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBlue_variantimg.png?v=1713502905',
                productJson: [[]]
              }, {
                product_color: 'Black Premium',
                color: 'Black',
                image: 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBlack_variantimg.png?v=1713502902',
                productJson: [[]]
              }, {
                product_color: 'Olive Premium',
                color: 'Olive Premium',
                image: 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPOlive_variantimg.png?v=1713502902',
                productJson: [[]]
              }, {
                product_color: 'Birch Premium',
                color: 'Birch Premium',
                image: 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMBPBirch_variantimg.png?v=1713502908',
                productJson: [[]]
              }
            ]
          }

            ,{
              title: 'SunShade',
              uri: storeLocale + '/products/sunshade',
              color: null,
              image: 'https://cdn.shopify.com/s/files/1/0519/0818/2188/files/MMVariant_sunshade.png?v=1686845880'
            }
            
          ],
          product: {
            uri: storeLocale + '/products/minimeis-g5-shoulder-carrier',
            color: null
          }
        };

        cartUpsellObj.init = function() {
          // var carrierCartItem = $('.cart-item[data-item-title="MiniMeis G5 Shoulder Carrier"]:first');

          var carrierCartItem = $('.cart-item[data-item-title="MiniMeis G5 Shoulder Carrier"]:first, .cart-item[data-item-title="MiniMeis G5 Carregador de Ombro"]:first');

          if (carrierCartItem.length && false) {

            var carrierCartItemTitle = carrierCartItem.find('.cart-item__name');
            cartUpsellObj.data.product.color = carrierCartItemTitle.next('dl').children('div:first').text().trim();

            var cartItems = $('.cart-items');

            cartItems.parents('.js-contents').after(
                    '<div class="cart-bottom__upsell-container">' +
                    '<ul class="cart-bottom__upsells"></ul>' +
                    '</div>'
            );

            var upsells = $('.cart-bottom__upsells');

            for (var i = 0; i < cartUpsellObj.data.upsells.length; i++) {
              var upsell = cartUpsellObj.data.upsells[i];
              console.log('cartUpsellObj', cartUpsellObj.data)
              if (!$('.cart-item[data-item-title="' + upsell.title + '"]').length) {
              let ii = i;
                upsells.append(
                        '<li class="cart-bottom__upsell" data-upsell-i="' + i + '"></li>'
                );

                console.log('upsell uri', upsell.uri)
                $.ajax({
                  url: upsell.uri,
                  dataType: 'html',
                  type: 'get',
                  upsell: $('.cart-bottom__upsell[data-upsell-i="' + i + '"]'),
                  upsellI: i,
                  success: function (result) {
                    var upsell = cartUpsellObj.data.upsells[this.upsellI];
                    var ajaxForm = $(result).find('.product-form');
                    if (typeof upsell.variants !== 'undefined') {
                      for (var i2 = 0; i2 < upsell.variants.length; i2++) {

                        var upsellVariant = upsell.variants[i2];
                        if (cartUpsellObj.data.product.color == upsellVariant.product_color) {
                          var upsellImage = upsellVariant.image;
                          upsell.color = upsellVariant.color;
                        }
                      }
                      var ajaxFormVariant = $(result).find('.product-form__input > input[type="radio"][value="' + upsell.color + '"]');

                    } else {
                      var ajaxFormVariant = $(result).find('.product-form__input > input[type="radio"]:first');
                    }


                    if(ajaxFormVariant.attr('data-available') != 'false'){

                      ajaxForm.children('form').append(
                              '<input type="hidden" name="' + ajaxFormVariant.attr('name') + '" value="' + ajaxFormVariant.attr('value') + '"/>'
                      );

                      ajaxForm.find('input[name="id"]').val(ajaxFormVariant.attr('data-variant-id'));

                      var ajaxPriceElem = $(result).find('#AddToCartPrice .price__regular .price-item--regular');
                      var productHandle = $(result).find('#AddToCartPrice .price__regular .price-item--regular').attr('data-product-handle');
                      var dataMoneyPrice = $(result).find('#AddToCartPrice .price__regular .price-item--regular').attr('data-money-price');
                      var ajaxPrice = ajaxPriceElem.text().trim();
                      var ajaxPriceValue = ajaxPrice.replace(/[^0-9\s\,\.]+/, '').replace(',','').replace('.','').trim()

                      if (upsell.title == 'MiniMeis Hero Parent Backpack' || upsell.title == 'Pouch') {

                        var currencySymbol = ajaxPrice.replace(/[0-9\s\,\.]+/, '').trim();
                        let market_currency = window.market.currency_iso_code;
                        if(currencySymbol == 'kr' && market_currency == 'SEK'){
                          ajaxPriceValue = (ajaxPriceValue.replace(' ', ''))*100
                          var ajaxDiscountPriceValue = (Number((ajaxPriceValue/100)).toLocaleString("ru-RU",{ minimumFractionDigits: 2, maximumFractionDigits: 2 }))+' '+currencySymbol;
                        }else if(currencySymbol == 'kr' && market_currency == 'NOK'){
                          ajaxPriceValue = ((ajaxPriceValue.replace(' ', '')))
                          var ajaxDiscountPriceValue = (Number((ajaxPriceValue/100)).toLocaleString("de-DE",{ minimumFractionDigits: 2, maximumFractionDigits: 2 }))+' '+currencySymbol;
                        }else if(currencySymbol == 'kr' && market_currency == 'DKK'){
                          ajaxPriceValue = ((ajaxPriceValue.replace(' ', '')))
                          var ajaxDiscountPriceValue = (Number((ajaxPriceValue/100)).toLocaleString("de-DE",{ minimumFractionDigits: 2, maximumFractionDigits: 2 }))+' '+currencySymbol;
                        }else{
                          var ajaxDiscountPriceValue = currencySymbol + (Number((ajaxPriceValue/100)).toLocaleString("de-DE",{ minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                        }


                        if (upsell.title == 'Pouch') {
                          var ajaxPrice = currencySymbol + ((ajaxPriceValue/100).toFixed(2));
                        } else {
                          if(currencySymbol == 'kr' && market_currency == 'SEK'){
                            var ajaxPrice = (Number((ajaxPriceValue * 0.85)/100).toLocaleString("ru-RU",{ minimumFractionDigits: 2, maximumFractionDigits: 2 })) + ' ' + currencySymbol;
                          }else if(currencySymbol == 'kr' && market_currency == 'NOK'){
                            var ajaxPrice = (Number(((ajaxPriceValue * 0.85)/100).toFixed(2)).toLocaleString("de-DE")) + ' ' + currencySymbol;
                          }else if(currencySymbol == 'kr' && market_currency == 'DKK'){
                            var ajaxPrice = (Number(((ajaxPriceValue * 0.85)/100).toFixed(2)).toLocaleString("de-DE")) + ' ' + currencySymbol;
                          }else{
                            var ajaxPrice = currencySymbol + (Number((ajaxPriceValue * 0.85)/100).toLocaleString("de-DE",{ minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                          }
                        }

                      } else {

                        var upsellImage = upsell.image;
                      }

                      this.upsell.html(
                              '<div class="cart-bottom__upsell-data">' +
                              '<p class="cart-bottom__upsell-text">' + $(result).find('.product-single__cart-upsell__text').html() +
                              '</p>' +
                              '<div class="cart-bottom__upsell-bottom">' +
                              '<span class="cart-bottom__upsell-prices">' +

                              (
                                      upsell.title == 'MiniMeis Hero Parent Backpack' ?
                                              '<span class="cart-bottom__upsell-price__old money">' + ajaxDiscountPriceValue + '</span>' : ''
                              )

                              + '<span class="cart-bottom__upsell-price__new money" data-product-handle="' + ajaxPriceElem.attr('data-product-handle') + '">' + ajaxPrice + '</span>' +
                              '</span>' +
                              '<button type="button" class="cart-bottom__upsell-btn">' +
                              $(result).find('.product-single__cart-upsell__btn').text() +
                              '</button>' +
                              '</div>' +
                              '</div>' +
                              '<div class="cart-bottom__upsell-image">' +
                              '<img src="' + upsellImage + '" alt="">' +
                              '</div>' +
                              '<div class="cart-bottom__upsell-form"></div>'
                      );

                      this.upsell.find('.cart-bottom__upsell-form').append(ajaxForm);

                      /* Upsell popup */
                      var upsellPopup = $(result).find('.product-single__upsell-details__popup');

                      if (upsellPopup.length) {
                        var upsellPopupCloned = upsellPopup.clone();
                        upsellPopupCloned.attr('id', 'productDetailsPopup' + this.upsellI + 'Content').addClass('hidden');
                        $('body').append(upsellPopupCloned);
                      }
                      /* /Upsell popup */

                      $('.cart-bottom__upsell-container').show();


                  }else{
                      $(`.cart-bottom__upsells [data-upsell-i="${ii}"]`).remove();
                    }

                  }
                });
              }
            }

            $(document).on('click', '.cart-bottom__upsell-btn', function () {
              var btn = $(this);
              btn.prop('disabled', true);

              var upsell = btn.parents('.cart-bottom__upsell');
              var upsellForm = upsell.find('.cart-bottom__upsell-form form');

              var upsellFormURL = upsellForm.attr('action');
              var upsellFormData = upsellForm.serialize();

              $.ajax({
                url: upsellForm.attr('action'),
                dataType: 'html',
                data: upsellFormData,
                type: 'post',
                success: function (result) {

                  $('#main-cart-footer .js-contents').html(
                          $(result).find('#main-cart-footer .js-contents').html()
                  );

                  $('#main-cart-items .js-contents').html(
                          $(result).find('#main-cart-items .js-contents').html()
                  );

                  upsell.remove();
                }
              });
            });

            /* Upsell popup */
            $(document).on('click', '.cart-bottom__upsell-text > .text-link', function() {
              console.log('click 2')
              var popupI = $(this).parents('.cart-bottom__upsell').attr('data-upsell-i');
              var popupId = 'productDetailsPopup' + popupI + 'Content';
              obj.showPopupById(popupId);

              var upsellImages = $('.product-single__upsell-popup__images');

              if (upsellImages.length  && false) {

                upsellImages.owlCarousel({
                  loop: true,
                  dots: false,
                  nav: true,
                  responsiveClass: true,
                  lazyLoad: true,
                  startPosition: 0,
                  responsive: {
                    0: {
                      margin: 5,
                      items: 1
                    },
                    768: {
                      margin: 5,
                      items: 3
                    }
                  }
                });
              }
            });
            /* /Upsell popup */
          }

          return cartUpsellObj;
        };

        cartUpsellObj.init();

        return cartObj;
      };

      cartObj.init();
    };
    obj.cart();

  } else if ($('body.template-article').length) {

    obj.article = function() {
      var sustainabilityTabs = $('.sustainability__tabs');

      if (sustainabilityTabs.length) {

        sustainabilityTabs.children('.sustainability__tab').each(function(i) {
          var sustainabilityTab = $(this);
          sustainabilityTab.attr('data-tab-i', i);
        });

        var sustainabilityTabsContent = $('.sustainability__tab-content');

        sustainabilityTabsContent.each(function(i) {
          var sustainabilityTabContent = $(this);
          sustainabilityTabContent.attr('data-tab-i', i);
        });

        if ($(window).width() < 750) {

          if (sustainabilityTabs.hasClass('owl-carousel')) {
            sustainabilityTabs.trigger('destroy.owl.carousel');
          }

        } else {

          if (!sustainabilityTabs.hasClass('owl-carousel')) {
            sustainabilityTabs.addClass('owl-carousel').addClass('owl-theme').owlCarousel({
              loop: false,
              dots: false,
              nav: false,
              responsiveClass: true,
              startPosition: 0,
              responsive: {
                0: {
                  mouseDrag: true,
                  touchDrag: true,
                  pullDrag: true,
                  loop: false,
                  margin: 10,
                  items: 2
                },
                750: {
                  margin: 20,
                  items: 3
                },
                990: {
                  margin: 20,
                  items: 3
                },
                1400: {
                  mouseDrag: false,
                  touchDrag: false,
                  pullDrag: false,
                  margin: 20,
                  items: 5
                }
              }
            });
          }
        }
      }

      $(document).on('click', '.sustainability__tabs a', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var articleTemplate = $('.article-template');
        articleTemplate.removeAttr('data-blog-level');

        var tab = $(this).parent('li');
        var tabI = tab.attr('data-tab-i');

        var tabsWrapper = tab.parents('.sustainability__tabs-wrapper');

        tabsWrapper.find('.sustainability__tab.active').removeClass('active');
        tab.addClass('active');

        tabsWrapper.find('.sustainability__tab-content.active').removeClass('active');
        var tabContent = tabsWrapper.find('.sustainability__tab-content[data-tab-i="' + tabI + '"]');
        tabContent.addClass('active');

        var tabs = tab.parents('.sustainability__tabs');
        tabs.addClass('opened');

        if (!tabs.hasClass('owl-carousel')) {
          tabs.addClass('owl-carousel').addClass('owl-theme').owlCarousel({
            loop: false,
            dots: false,
            nav: false,
            responsiveClass: true,
            startPosition: 0,
            responsive: {
              0: {
                mouseDrag: true,
                touchDrag: true,
                pullDrag: true,
                loop: false,
                margin: 10,
                items: 2
              },
              750: {
                margin: 20,
                items: 3
              },
              990: {
                margin: 20,
                items: 3
              },
              1400: {
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                margin: 20,
                items: 5
              }
            }
          });
        }

        tabs.trigger ('to.owl.carousel', [
          tabI, 300
        ]);
      });

      $(document).on('click', '.sustainability__tabs-grid .sustainability__tab-grid > li > a', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var gridLink = $(this);

        if (gridLink.parent('li').hasClass('active')) {

        } else {
          var gridLinkI = gridLink.parent('li').index();

          gridLink.parent('li').addClass('active').siblings('.active').removeClass('active');

          var originalGridLink = $('.sustainability__tab-columns .sustainability__tab-grid.opened > li:eq(' + gridLinkI + ') > a');
          originalGridLink.click();
        }
      });

      $(document).on('click', '.sustainability__tab-columns .sustainability__tab-grid > li > a', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var gridLink = $(this);

//         if (gridLink.parent('li').hasClass('active')) {

//         } else {
        gridLink.parent('li').addClass('active').siblings('.active').removeClass('active');

        var articleTemplate = $('.article-template');

        var gridContent = $('.sustainability__tab-grid__content');

        var gridTitle = gridContent.find(' > header > h1 > span');
        gridTitle.text(gridLink.children('b.h6').text().trim());

        var gridSubtitle = gridContent.find(' > header > h1 > small');
        gridSubtitle.text($('.sustainability__tab.active').text().trim());

        var gridText = gridContent.children('div');
        gridText.html(gridLink.siblings('div').html());

        articleTemplate.attr('data-blog-level', '3');

        $('html,body').animate({
          scrollTop: $('.sustainability__tabs-wrapper').offset().top
        }, 0);

        articleTemplate.find('.sustainability__tab-columns .sustainability__tab-grid.opened').removeClass('opened');

        var grid = gridLink.parents('.sustainability__tab-grid');
        grid.addClass('opened');
        $('.sustainability__tabs-grid').html(grid.clone());
//         }
      });

      $(document).on('click', '.sustainability__tab-grid__content a[data-sustainability-grid-id]', function() {
        var link = $(this);
        var gridId = link.attr('data-sustainability-grid-id');
        var grid = $('#' + gridId + ' > a');

        if (grid.length) {
          grid.click();
        }
      });

//       $('.sustainability__tab:eq(3) a').click();

//       $('.sustainability__tab-grid > li:first a').click();

      return obj;
    };
    obj.article();
  }

  obj();
});
